const React = require("react");

function AngleDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m360.5 217.5-152 143.1c-4.6 5.2-10.6 7.4-16.5 7.4s-11.88-2.188-16.5-6.562L23.5 217.5c-9.63-9.2-10.03-24.4-.94-34 9.13-9.7 24.38-10 33.94-.9L192 310.9l135.5-128.4c9.562-9.094 24.75-8.75 33.94.937 9.06 9.663 8.66 24.863-.94 34.063z"
  }));
}

const ForwardRef = React.forwardRef(AngleDownIcon);
module.exports = ForwardRef;